// Botão de cópia com feedback "Copiado ✓" (verde) temporário. Copiar campo a campo
// é o gesto central: o médico cola no prontuário oficial. `onCopiado` permite um
// efeito extra após a cópia (o cabeçalho usa para POST /copiada — congelar diffs).

import { useEffect, useRef, useState, type CSSProperties, type MouseEvent } from 'react';

import { copiar } from '../../lib/clipboard';
import { btnCopiado, btnSecundario } from '../../styles/tokens';

interface Props {
  texto: string;
  rotulo: string;
  rotuloCopiado?: string;
  style?: CSSProperties;
  onCopiado?: () => void | Promise<void>;
  disabled?: boolean;
}

export function CopiarBotao({
  texto,
  rotulo,
  rotuloCopiado = 'Copiado ✓',
  style,
  onCopiado,
  disabled,
}: Props): JSX.Element {
  const [copiado, setCopiado] = useState(false);
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  async function aoClicar(e: MouseEvent): Promise<void> {
    e.stopPropagation(); // não acionar o clique-para-editar do campo ao redor
    const ok = await copiar(texto);
    if (!ok) return;
    setCopiado(true);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setCopiado(false), 2500);
    if (onCopiado) await onCopiado();
  }

  return (
    <button
      type="button"
      onClick={aoClicar}
      disabled={disabled}
      style={{
        ...(copiado ? btnCopiado : btnSecundario),
        height: 30,
        fontSize: 12.5,
        ...(copiado ? {} : style),
      }}
    >
      {copiado ? rotuloCopiado : rotulo}
    </button>
  );
}
